// Hårt tak för den totala storleken på inbäddade base64-bilder i meddelandets brödtext.
export const BASE64_IMAGES_MAX_TOTAL_BYTES = 10 * 1024 * 1024;

// Hittar data-URI:er för bilder (data:image/png;base64,....) och fångar själva base64-datan.
const base64ImageRegex = /data:image\/[^;"'&\s]+;base64,([A-Za-z0-9+/]+=*)/gi;

// Summerar den avkodade storleken (bytes) på alla base64-bilder i innehållet.
export const sumBase64ImageBytes = (content?: string | null): number => {
  if (!content) return 0;
  let total = 0;
  Array.from(content.matchAll(base64ImageRegex)).forEach((match) => {
    const data = match[1];
    const padding = data.length - data.replace(/=+$/, '').length;
    total += Math.floor((data.length * 3) / 4) - padding;
  });
  return total;
};

// True när base64-bilderna tillsammans överstiger taket och meddelandet inte får sparas.
export const base64ImagesExceedMax = (content?: string | null): boolean => sumBase64ImageBytes(content) > BASE64_IMAGES_MAX_TOTAL_BYTES;
